import * as React from 'react';
import notify from '../../../../shared/feedback/notifications';
import * as PhotoStatus from '../../../../shared/PhotoStatus';
import * as actions from './actions/ImageProcessingActions';
import Api from '../../../../shared/Api';
import { handleError } from '../../../../shared/ErrorCatching';
import ImageDeliveryOptionsDropdown from './ImageDeliveryOptionsDropdown';
import { isBrokerAgent } from '../../utils/brokerAgentUtils';
import { Translate } from '../../../../shared/LanguageService';
import CopyLinkModal from './CopyLinkModal';
import { Resolution } from './Entities';

class ImageProcessingDeliveryOptions extends React.Component<any, any> {
    constructor(props: any, context: any) {
        super(props, context);
        this.state = {
            normalImagesAvailble: this.props.normalImagesAvailble,
            isLoadingListImages: false,
            downloading: false,
            downloadLink: null,
            isLinkModalOpen: false
        };

        this.downloadLink = this.downloadLink.bind(this);
        this.downloadEditedImages = this.downloadEditedImages.bind(this);
        this.emailImages = this.emailImages.bind(this);
    }

    downloadLink(resolution: Resolution) {
        this.setState({ isLinkModalOpen: true });

        actions
            .getZipDownloadLink(this.props.orderId, resolution)
            .then((result) => {
                this.setState({ downloadLink: result.downloadLink });
            })
            .catch((error) => {
                this.setState({ isLinkModalOpen: false });
                handleError(error);
            });
    }

    emailImages(resolution: Resolution) {
        actions
            .emailImages(this.props.orderId, resolution)
            .then(() => {
                notify.success(Translate('image-processing/notification/mail-sent'));
            })
            .catch(handleError);
    }

    downloadEditedImages(isNormal: boolean) {
        this.setState({
            downloading: true,
            downloading_normal: isNormal,
            downloading_edited: !isNormal
        });

        let { user } = this.props;
        let isBroker = isBrokerAgent(user.details.role);

        new Api()
            .downloadFile(
                `/views/orders/${
                    this.props.orderId
                }/imageprocessing/download?isEdited=1&isNormalResolution=${
                    isNormal ? 1 : 0
                }&isBroker=${isBroker ? 1 : 0}`
            )
            .then(() => {
                this.setState({
                    downloading: false,
                    downloading_normal: false,
                    downloading_edited: false
                });
            })
            .catch(() => {
                this.setState({
                    downloading: false,
                    downloading_normal: false,
                    downloading_edited: false
                });
            });
    }

    render() {
        return (
            <>
                <CopyLinkModal
                    open={this.state.isLinkModalOpen}
                    onClose={() => this.setState({ isLinkModalOpen: false })}
                    link={this.state.downloadLink}
                />
                {(this.props.photoStatus === PhotoStatus.CustomerApproved ||
                    this.props.photoStatus === PhotoStatus.Delivered ||
                    this.props.photoStatus === PhotoStatus.ScheduledForCustomerApproval ||
                    this.props.photoStatus === PhotoStatus.DeliveryStarted ||
                    this.props.photoStatus === PhotoStatus.DeliveryError ||
                    this.props.photoStatus === PhotoStatus.SetToRedeliver) && (
                    <ImageDeliveryOptionsDropdown
                        downloading={this.state.downloading}
                        user={this.props.user}
                        photoStatus={this.props.photoStatus}
                        emailImages={this.emailImages}
                        downloadLink={this.downloadLink}
                        downloadImages={this.downloadEditedImages}
                        normalImagesAvailable={this.props.normalImagesAvailable}
                        site={this.props.site}
                    />
                )}
            </>
        );
    }
}

export default ImageProcessingDeliveryOptions;
